import React, { useState } from "react";
import {
  Container,
  Typography,
  Box,
  makeStyles,
  Paper,
  Tabs,
  Tab,
  IconButton,
  Tooltip
} from "@material-ui/core";
import {
  Refresh as RefreshIcon,
  Settings as SettingsIcon
} from "@material-ui/icons";
import { toast } from "react-toastify";
import useVPSMonitoring from "./hooks/useVPSMonitoring";
import SystemStatus from "./components/SystemStatus";
import FileManager from "./components/FileManager";
// ✅ ELIMINADO: ThresholdsConfig - Ya no se necesita la pestaña de configuración
import CleanupActions from "./components/CleanupActions";
import HistoryChart from "./components/HistoryChart";
import VPSActionHistory from "./components/VPSActionHistory";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1)
    }
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: theme.spacing(1)
    }
  },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  actions: {
    display: "flex",
    gap: theme.spacing(1)
  },
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: 12
  },
  tabs: {
    marginBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  tabContent: {
    padding: theme.spacing(2, 0)
  }
}));

const VPSPerformance = () => {
  const classes = useStyles();
  const [tabValue, setTabValue] = useState(0);
  const {
    loading,
    error,
    systemStatus,
    fileAnalysis,
    history,
    thresholds,
    databaseActivity,
    autoRefresh,
    refreshAll,
    forceRefresh,
    fetchHistory,
    fetchDatabaseActivity,
    setAutoRefresh,
    executeCleanup
  } = useVPSMonitoring();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    // Cargar historial cuando se selecciona la pestaña de gráficos
    // ✅ AJUSTADO: Ahora Gráficos es índice 3, Historial de Acciones es índice 4
    if (newValue === 3) {
      fetchHistory(7);
    }
  };

  const handleRefresh = async () => {
    toast.info("Actualizando datos...");
    await forceRefresh(); // Usar forceRefresh para ejecutar scripts y guardar en historial
    toast.success("Datos actualizados");
  };

  const handleToggleAutoRefresh = () => {
    setAutoRefresh(!autoRefresh);
    toast.info(`Actualización automática ${!autoRefresh ? "activada" : "desactivada"}`);
  };

  return (
    <Container maxWidth="xl" className={classes.container}>
      {/* Header */}
      <Box className={classes.header}>
        <Typography variant="h4" className={classes.title}>
          <span role="img" aria-label="Servidor">🖥️</span> Rendimiento VPS
        </Typography>
        <Box className={classes.actions}>
          <Tooltip title={autoRefresh ? "Desactivar auto-actualización" : "Activar auto-actualización"}>
            <IconButton
              onClick={handleToggleAutoRefresh}
              color={autoRefresh ? "primary" : "default"}
            >
              <SettingsIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Actualizar ahora">
            <span>
              <IconButton onClick={handleRefresh} disabled={loading}>
                <RefreshIcon />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      </Box>

      {/* Tabs */}
      <Paper className={classes.paper}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          className={classes.tabs}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Estado del Sistema" />
          <Tab label="Gestión de Archivos" />
          {/* ✅ ELIMINADO: Pestaña "Configuración" - Ya no se necesita */}
          <Tab label="Acciones" />
          <Tab label="Gráficos" />
          <Tab label="Historial de Acciones" />
        </Tabs>

        <Box className={classes.tabContent}>
          {tabValue === 0 && (
            <SystemStatus
              loading={loading}
              error={error}
              systemStatus={systemStatus}
              thresholds={thresholds}
              databaseActivity={databaseActivity}
              onRefreshDatabaseActivity={fetchDatabaseActivity}
            />
          )}
          {tabValue === 1 && (
            <FileManager
              loading={loading}
              error={error}
              fileAnalysis={fileAnalysis}
              onRefresh={refreshAll}
            />
          )}
          {/* ✅ ELIMINADO: Pestaña "Configuración" (tabValue === 2) - Ya no se necesita */}
          {tabValue === 2 && (
            <CleanupActions
              loading={loading}
              error={error}
              onAction={executeCleanup}
            />
          )}
          {tabValue === 3 && (
            <HistoryChart
              loading={loading}
              error={error}
              history={history}
              onFetchHistory={fetchHistory}
            />
          )}
          {tabValue === 4 && <VPSActionHistory />}
        </Box>
      </Paper>
    </Container>
  );
};

export default VPSPerformance;
